import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import StockorderproductEditFormImpl from './StockorderproductEditFormImpl';
import StockorderproductList from './StockorderproductList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import StockorderproductListView from './StockorderproductListView'


export default function StockorderproductDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.stockorderproductDashboard);
  const [ stockorderproductId, setStockorderproductId] = React.useState('');
  const [reloadStockorderproductList, setReloadStockorderproductList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <StockorderproductEditFormImpl 
            setReloadStockorderproductList={setReloadStockorderproductList}
            stockorderproductId={stockorderproductId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <StockorderproductListView 
                      setStockorderproductId = {setStockorderproductId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
